var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M473.655,88.276H38.345C17.167,88.276,0,105.443,0,126.621v73.471h512v-73.471 C512,105.443,494.833,88.276,473.655,88.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M0,385.379c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345 v-73.471H0V385.379z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 200.09,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 111.81
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M128.095,261.47c2.532-3.207,2.532-7.733,0-10.94L9.939,100.864C3.764,107.671,0,116.706,0,126.621 V385.38c0,9.914,3.764,18.95,9.939,25.757L128.095,261.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B46446"
    },
    d: "M253.881,263.896c0,0.216-0.071,20.968-5.378,31.177h14.913c-5.308-10.208-5.378-30.961-5.378-31.177 c0-7.15,7.411-12.832,7.486-12.888l-2.497-3.322c-0.194,0.146-2.664,2.039-4.988,5.114v-5.53h-4.157v5.53 c-2.324-3.075-4.793-4.969-4.988-5.114l-2.497,3.322C246.472,251.064,253.881,256.745,253.881,263.896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M276.745,238.955c-0.127,0-0.244,0.033-0.37,0.041c-0.847-2.438-3.14-4.198-5.866-4.198 c-0.983,0-1.9,0.248-2.727,0.653c-0.881-1.619-2.575-2.731-4.547-2.731c-0.567,0-1.102,0.114-1.613,0.281 c-1.106-2.609-3.689-4.438-6.7-4.438c-3.701,0-6.722,2.774-7.181,6.349c-0.372-0.058-0.745-0.114-1.132-0.114 c-4.018,0-7.275,3.257-7.275,7.275c0,0.472,0.053,0.931,0.139,1.378c-1.841,0.606-3.289,2.029-3.925,3.855 c-0.124-0.011-0.244-0.038-0.371-0.038c-2.296,0-4.157,1.862-4.157,4.157c0,2.296,1.862,4.157,4.157,4.157 c1.06,0,2.018-0.409,2.752-1.064c0.994,0.671,2.193,1.064,3.484,1.064c1.142,0,2.197-0.329,3.117-0.865 c0.92,0.535,1.976,0.865,3.117,0.865c3.444,0,6.236-2.792,6.236-6.236c0-0.264-0.046-0.514-0.077-0.769 c0.968,0.477,2.042,0.769,3.196,0.769c1.446,0,2.784-0.434,3.916-1.161c1.063,1.922,3.085,3.239,5.437,3.239 c0.505,0,0.991-0.076,1.461-0.19c1.144,1.375,2.846,2.269,4.774,2.269c1.863,0,3.517-0.833,4.659-2.129 c3.204-0.259,5.734-2.913,5.734-6.185C282.98,241.747,280.189,238.955,276.745,238.955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5FA000"
    },
    d: "M270.509,244.151c0-0.216,0.045-0.42,0.064-0.631c-1.112,1.028-2.586,1.671-4.221,1.671 c-2.172,0-4.079-1.112-5.196-2.796c-1.117,1.684-3.025,2.796-5.196,2.796c-1.67,0-3.177-0.665-4.297-1.734 c-0.648,3.354-3.592,5.89-7.135,5.89c-0.36,0-0.704-0.055-1.049-0.106c0.001,0.036,0.011,0.07,0.011,0.106 c0,2.718-1.749,5.005-4.175,5.859c0.657,0.235,1.358,0.376,2.097,0.376c1.142,0,2.197-0.329,3.117-0.865 c0.92,0.535,1.976,0.865,3.117,0.865c3.444,0,6.236-2.792,6.236-6.236c0-0.264-0.046-0.514-0.077-0.769 c0.968,0.477,2.042,0.769,3.196,0.769c1.446,0,2.784-0.434,3.916-1.161c1.063,1.922,3.085,3.239,5.437,3.239 c0.505,0,0.991-0.076,1.461-0.19c1.144,1.375,2.846,2.269,4.773,2.269c1.863,0,3.517-0.833,4.659-2.129l0.013-0.002 C273.491,251.1,270.509,247.989,270.509,244.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M255.96,308.321c-0.334,0-0.63-0.213-0.739-0.527c-0.079-0.234-2.036-5.706-9.653-5.706h-10.392 c-6.161,0-11.171-5.012-11.171-11.171v-68.588c0-0.43,0.349-0.779,0.779-0.779h64.431c0.43,0,0.779,0.349,0.779,0.779v68.588 c0,6.161-5.012,11.171-11.171,11.171h-12.471c-7.663,0-9.634,5.644-9.652,5.702c-0.107,0.319-0.403,0.532-0.738,0.532h-0.002 V308.321z M225.562,223.106v67.809c0,5.3,4.312,9.613,9.613,9.613h10.392c6.169,0,9.155,3.313,10.392,5.303 c1.237-1.992,4.223-5.303,10.392-5.303h12.471c5.301,0,9.613-4.313,9.613-9.613v-67.809L225.562,223.106L225.562,223.106z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "247.983,203.795 249.959,206.956 253.684,207.085 251.933,210.376 253.684,213.667  249.959,213.796 247.983,216.958 246.009,213.796 242.284,213.667 244.034,210.376 242.284,207.085 246.009,206.956  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "230.425,206.662 233.084,209.274 236.736,208.53 235.802,212.138 238.273,214.93  234.681,215.925 233.5,219.46 230.841,216.847 227.189,217.592 228.122,213.983 225.652,211.192 229.244,210.197  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "213.578,211.647 216.738,213.625 220.143,212.109 220.011,215.834 223.026,218.026  219.734,219.774 219.343,223.481 216.183,221.504 212.778,223.019 212.91,219.294 209.895,217.102 213.187,215.354  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "264.017,203.795 262.041,206.956 258.316,207.085 260.067,210.376 258.316,213.667  262.041,213.796 264.017,216.958 265.991,213.796 269.716,213.667 267.966,210.376 269.716,207.085 265.991,206.956  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "281.575,206.662 278.916,209.274 275.264,208.53 276.198,212.138 273.727,214.93  277.319,215.925 278.5,219.46 281.159,216.847 284.811,217.592 283.878,213.983 286.348,211.192 282.756,210.197  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "298.422,211.647 295.262,213.625 291.857,212.109 291.989,215.834 288.974,218.026  292.266,219.774 292.657,223.481 295.817,221.504 299.222,223.019 299.09,219.294 302.105,217.102 298.813,215.354  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGq);
export default __webpack_public_path__ + "static/media/gq.de38685d95ff1274b7c3d16ca9d7af92.svg";
export { ForwardRef as ReactComponent };